export default __webpack_public_path__ + "static/media/SairaExtraCondensed-ExtraLight.d194b8f9.ttf";